import { IconProps } from '@/components/Icon';

export const IconSpinner = ({ width = 18, height = 18, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 18 18' width={width} xmlns='http://www.w3.org/2000/svg'>
      <circle cx='16.0743' cy='9.16959' fill={color} opacity='0.8' r='1.68174' />
      <circle cx='13.9119' cy='14.3914' fill={color} opacity='0.7' r='1.60626' />
      <circle cx='8.68978' cy='16.5545' fill={color} opacity='0.6' r='1.44564' />
      <circle cx='3.46728' cy='14.3915' fill={color} opacity='0.5' r='1.30107' transform='rotate(45 3.46728 14.3915)' />
      <circle cx='1.30524' cy='9.32899' fill={color} opacity='0.4' r='1.17097' />
      <circle cx='3.35498' cy='4.06053' fill={color} opacity='0.3' r='1.05387' transform='rotate(45 3.35498 4.06053)' />
      <circle cx='8.69001' cy='1.78474' fill={color} r='1.78474' />
      <circle cx='13.9122' cy='3.94764' fill={color} opacity='0.9' r='1.78474' />
    </svg>
  );
};
